import type { FC } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { useLogoImageQuery } from 'hooks';


const LogoImage: FC = () => {
  const logoImageData = useLogoImageQuery();
  const logoImage = getImage(logoImageData);

  if (!logoImage) {
    return null;
  }

  return <GatsbyImage image={logoImage} alt='Logo' objectFit='contain' style={{ display: 'flex' }} />;
};

export default LogoImage;
